import { OrderMetadataStateModel } from './order-metadata.type';

export class SetOrderMetadata {
  static readonly type = '[Order] Set Metadata';
  constructor(public payload: OrderMetadataStateModel) {}
}

export class ClearOrderMetadata {
  static readonly type = '[Order] Clear Metadata';
}
